// Cached getBoundingClientRect. Callers ask for the canvas rect at
// pointermove rate (twice per event during an LMB drag), and each call forces
// a style/layout flush — but the rect only changes on viewport resize, scroll,
// or the element itself being resized. So: cache per element, invalidate on
// exactly those events. Dependency-free so any layer can use it.

const _rects = new Map<Element, DOMRect>();

// ResizeObserver fires once immediately on observe() — that just evicts the
// entry we're about to (re)compute, which is harmless.
const _observer = new ResizeObserver((entries) => {
  for (const e of entries) _rects.delete(e.target);
});

let _windowHooked = false;
function hookWindow(): void {
  if (_windowHooked) return;
  _windowHooked = true;
  window.addEventListener("resize", () => _rects.clear());
  window.addEventListener("scroll", () => _rects.clear(), {
    capture: true,
    passive: true,
  });
}

export function elementRect(el: Element): DOMRect {
  let r = _rects.get(el);
  if (!r) {
    hookWindow();
    _observer.observe(el); // idempotent for an already-observed element
    r = el.getBoundingClientRect();
    _rects.set(el, r);
  }
  return r;
}
